import { api } from "./api";

// ===============================================================
// Master alasan pergerakan stok — Batch 2.3.
//
// Sumber tunggal untuk seluruh frontend. JANGAN menyalin konstanta
// alasan ke halaman mana pun: alasan adalah data yang bisa Owner tambah,
// dan salinan konstanta akan langsung basi.
//
// TIDAK ADA DAFTAR ALASAN CADANGAN DI SINI. Kalau master tidak terbaca,
// pilihan tampil kosong dan pengguna tidak bisa menyimpan — bukan
// diam-diam memakai "normal". Diam-diam normal persis kegagalan yang
// batch ini dibuat untuk mencegahnya.
// ===============================================================

const _cache = {};
const _inflight = {};

/**
 * Ambil alasan aktif.
 * @param {string} context "all" | "manual_adjustment"
 */
export async function fetchStockReasons(context = "all", { force = false } = {}) {
  if (_cache[context] && !force) return _cache[context];
  if (_inflight[context] && !force) return _inflight[context];
  _inflight[context] = api
    .get("/stock-reason-codes", { params: { context } })
    .then((r) => {
      _cache[context] = r.data || [];
      return _cache[context];
    })
    .finally(() => {
      delete _inflight[context];
    });
  return _inflight[context];
}

export function clearStockReasonsCache() {
  Object.keys(_cache).forEach((k) => delete _cache[k]);
}

/** Label alasan; fallback ke kode mentah supaya baris lama tetap terbaca. */
export function reasonLabel(reasons, code) {
  const hit = (reasons || []).find((r) => r.code === code);
  return hit ? hit.name : code;
}

// Tujuan pengeluaran bahan (material_issue.purpose).
// Ini CHECK dua nilai di database, bukan tabel master — keduanya punya
// perlakuan biaya berbeda di kode, jadi sengaja bukan data.
export const ISSUE_PURPOSES = [
  {
    value: "NORMAL",
    label: "Pemakaian normal",
    hint: "Bahan untuk produksi yang direncanakan.",
  },
  {
    value: "REJECT_REMAKE",
    label: "Pengganti reject / remake",
    hint: "Bahan pengganti akibat kegagalan produksi. Wajib menunjuk kejadian reject-nya.",
  },
];
